import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { WorkOrder } from '../WorkOrder'
import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'

@InputType()
export class CreateFromWorkOrderItemArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  workOrderInput?: WorkOrder //this is the new work order info that needs to be created

  @Field(() => String)
  workOrderItemId?: string //this is the current work order item that the new work order will be attached into

  @Field(() => String)
  parentWorkOrderId: string
}

export interface ICreateFromWorkOrderItem extends IAction<WorkOrder, CreateFromWorkOrderItemArgs> {}
